import React from 'react';

import { Messages } from '../../../codegen/Localize';
import { IServerUserInfo } from '../../../ts/models/IServerUserInfo';
import { IGetUserSettingsResult } from '../../../ts/ServerApi/requests/GetUserSettingsRequest';
import { SiteRoleOptionsResource } from '../../../userManagement/services/resources/SiteRoleOptions';
import { UserSettingsSubspace } from '../../../userSettings/components/UserSettingsSubspace';
import { UserSpaceHeader } from '../SiteUserSpace/SiteUserSpaceHeader';
import { Subspace, TabbedSpace } from '../TabbedSpace';

export interface ServerUserSpaceProps {
  readonly user: IServerUserInfo;
  readonly userSettings: IGetUserSettingsResult;
  readonly userRefreshTokenCount: number;
  readonly isSessionUserSelf: boolean;
  readonly siteRoleOptions: SiteRoleOptionsResource;
}

export class ServerUserSpace extends React.PureComponent<ServerUserSpaceProps> {
  public render(): JSX.Element {
    const subspaces = getServerUserSubspaces(this.props);
    return (
      <TabbedSpace
        subspaces={subspaces}
        activeSubspaceName={'settings'}
        urlForSubspace={this.urlForSubspace}
        mastheadElement={this.mastheadElement()}
        testIdPrefix={'serveruser'}
        spaceItemName={this.props.user.displayName}
      />
    );
  }

  private urlForSubspace = () => '';

  private mastheadElement = (): React.ReactNode => {
    return (
      <UserSpaceHeader
        item={this.props.user}
        inServerArea={true}
        siteRole={this.props.user.maxSiteRole}
        siteRoleOptions={this.props.siteRoleOptions}
        userSettings={this.props.userSettings}
        isSessionUserSelf={this.props.isSessionUserSelf}
        isSessionServerAdmin={true}
        isSessionSiteAdmin={false}
        isServerDomainFamilyActiveDirectory={false}
      />
    );
  }
}

function getServerUserSubspaces(serverUserSpaceProps: ServerUserSpaceProps): ReadonlyArray<Subspace> {
  return [
    {
      name: 'settings',
      tabLabel: Messages.settings(),
      shouldRenderTabContentCount: false,
      renderContent: () =>
      <UserSettingsSubspace
        userSettings={serverUserSpaceProps.userSettings}
        userRefreshTokenCount={serverUserSpaceProps.userRefreshTokenCount}
        isSessionUserSelf={serverUserSpaceProps.isSessionUserSelf}
        serverUser={serverUserSpaceProps.user}
        isServerUserSubplace={true}/>
    }
  ];
}
